import CameraAltRoundedIcon from '@material-ui/icons/CameraAltRounded';
import { useState } from 'react';
import server from '../../apis/server';
import UploadButton from '../UploadButton';
import styles from './ProfilePic.module.css';

const ProfilePic = ({ size, url, upload }) => {
  const [imgHash, setImgHash] = useState(Date.now());

  let sizeClass;

  if (size === 'large') {
    sizeClass = styles.large;
  } else if (size === 'medium') {
    sizeClass = styles.medium;
  } else {
    sizeClass = styles.small;
  }

  const onFileUpload = async (e) => {
    const file = e.target.files[0];

    const formData = new FormData();
    formData.append('upload', file);

    try {
      await server.post('/images/avatar', formData);

      setImgHash(Date.now());
    } catch (err) {}
  };

  return (
    <div className={styles.container}>
      <img
        src={`${url}?${imgHash}`}
        alt=""
        className={`${styles.picture} ${sizeClass}`}
      />
      {upload && (
        <UploadButton id="profile-pic-upload" onUpload={onFileUpload}>
          <div className={styles.overlay}>
            <CameraAltRoundedIcon
              className={styles.uploadIcon}
              style={{ fontSize: '2rem' }}
            />
          </div>
        </UploadButton>
      )}
    </div>
  );
};

export default ProfilePic;
